import style from "./style.module.css";
import lectureinfo from "../../../assets/modalIcons/etkinlik.svg";
import cross from "../../../assets/modalIcons/cross.svg";
import deleteicon from "../../../assets/modalIcons/delete.svg";
import save from "../../../assets/modalIcons/save.svg";
import excel from "../../../assets/modalIcons/excel.svg";
import { useContext, useState,useRef,useEffect } from "react";
import StoreContext from "../../../context/store";
import { deletePayment, editPayment } from "../../../api/general";
import {
  successMessage,
  errorMessage,
  warningMessage,
} from "../../../helpers/toast";
import DatePicker from "react-datepicker";
import tr from "date-fns/locale/tr";
import calendar from "../../../assets/calendaricon.svg";
import { getClassrooms } from "../../../api/general";
import useClickOutside from "../../../hooks/useClickOutside";
import dropdown from "../../../assets/arrowdown.svg";

const EditPaymentModal = ({ paymentId }) => {
  const { setEditPaymentClick, payment } = useContext(StoreContext);

  const [paymentname, setPaymentname] = useState(payment.etkinlikname);
  const [classroomId, setClassroomId] = useState("");
  const [classroomIds, setClassroomIds] = useState([]);
  const [startDate, setStartDate] = useState(new Date(payment.baslangictarih));
  const [endDate, setEndDate] = useState(new Date(payment.bitistarih));
  const [price, setPrice] = useState(payment.tutar);
  const [place, setPlace] = useState(payment.yer);
  const [mebfile, setMebfile] = useState(null);
  const [photo, setPhoto] = useState(null);

  const [classroomName, setClassroomName] = useState("");
  const [classroomNames, setClassroomNames] = useState([]);

  // FOR CLASSROOM DROPDOWN

  const [optionArea2, setOptionArea2] = useState(false);
  const buttonRef2 = useRef(null);

  const [classrooms, setClassrooms] = useState([]);

  useEffect(() => {
    getClassroomsMethod();
  }, []); //

  // FOR CLASSROOM DROPDOWN

  useClickOutside(buttonRef2, () => {
    setOptionArea2(false);
  });

  const handleToggle2 = () => {
    setOptionArea2(!optionArea2);
  };

  /*const handleClassroomSelect = (event) => {
    setClassroomName(event.target.value.split(",")[0]);
    setClassroomId(event.target.value.split(",")[1]);
    setOptionArea2(false);
  };*/
  const handleClassroomSelect = (event) => {
    const selectedClassroomId = Number(event.target.value.split(",")[1]);
    const selectedClassName = event.target.value.split(",")[0];

    // Sınıf zaten seçiliyse kaldır, değilse ekle
    if (classroomIds.includes(selectedClassroomId)) {
      const updatedIds = classroomIds.filter(
        (id) => id !== selectedClassroomId
      );
      setClassroomIds(updatedIds);

      const updatedNames = classroomNames
        .split(",")
        .filter((name) => name !== selectedClassName)
        .join(",");
      setClassroomNames(updatedNames);
    } else {
      setClassroomIds([...classroomIds, selectedClassroomId]);

      const updatedNames =
        classroomNames === ""
          ? selectedClassName
          : `${classroomNames},${selectedClassName}`;
      setClassroomNames(updatedNames);
    }
    setOptionArea2(false);
  };

  const getClassroomsMethod = async () => {
    const response = await getClassrooms();
    if (response.error) {
      console.log("Test sınıflar gelmedi");
    } else {
      console.log("Test sınıflar geldi");
      setClassrooms(response.data);
    }
  }; //


  const deletePaymentMethod = async () => {
    const response = await deletePayment(paymentId);
    if (response.error) {
      console.log("Ödeme silme başarısız");
      console.log(response.error, "response.erro");
      errorMessage(response.error.response.data.error);
      errorMessage("Ödeme silinemedi");
    } else {
      console.log("Ödeme silme başarılı");
      successMessage("Ödeme silindi");
      setEditPaymentClick(false);

      setTimeout(function () {
        window.location.reload();
      }, 2500);
    }
  };

  const editPaymentMethod = async () => {
    if (
      paymentname === "" ||
      classroomIds === "" ||
      startDate === "" ||
      endDate === "" ||
      price === "" ||
      place === "" 
    ) {
      warningMessage("Lütfen boş alan bırakmayınız");

      return;
    }

    const response = await editPayment(
      paymentname,
      classroomIds,
      startDate,
      endDate,
      price,
      place,
      mebfile,
      photo,
      paymentId
    );
    if (response.error) {
      console.log("Ödeme güncelleme başarısız");
      console.log(response.error, "response.erro");
      errorMessage(response.error.response.data.error);
      errorMessage("Ödeme güncellenemedi");
    } else {
      console.log("Ödeme güncelleme başarılı");
      successMessage("Ödeme güncellendi");
      setEditPaymentClick(false);

     /* setTimeout(function () {
        window.location.reload();
      }, 2500); */
    }
  };

  return (
    <div className={style.modal}>
      <div className={style.modalbox}>
        <div className={style.uppertabs}>
          <div className={style.tableftside}>
            <div className={style.tab1}>
              <button className={style.tabicon1}>
                <img alt="" src={lectureinfo}></img>
              </button>
              <div className={style.tabtext1}>Etkinlik</div>
            </div>
          </div>
          <div className={style.tabrightside}>
            <div className={style.tab}>
              <button
                className={style.tabicon}
                onClick={() => {
                  setEditPaymentClick(false);
                }}
              >
                <img alt="" src={cross}></img>
              </button>
              <div className={style.tabtext}>Kapat</div>
            </div>
          </div>
        </div>
        <div className={style.inputs}>
          <div className={style.input}>
            <div className={style.inputtitle}>Etkinlik Adı</div>
            <input
              className={style.inputtext}
              value={paymentname}
              onChange={(e) => setPaymentname(e.target.value)}
            ></input>
          </div>
          <div className={style.input}>
            <div className={style.inputtitle}>Sınıfı</div>
            <div className={style.dropdown}>
              <div className={style.selectedoption}>{classroomNames}</div>
              <button onClick={handleToggle2}>
                <img src={dropdown} alt=""></img>
              </button>

              {/*  {optionArea2 && (
                <div className={style.optionarea} ref={buttonRef2}>
                  <div>
                    {classrooms &&
                      classrooms.map((classroom, index) => (
                        <button
                          onClick={handleClassroomSelect}
                          value={[classroom.sinifname, classroom.id]}
                          key={index}
                          className={style.option}
                        >
                          {classroom.sinifname}
                        </button>
                      ))}
                  </div>
                </div>
              )} */}
              {optionArea2 && (
                <div className={style.optionarea} ref={buttonRef2}>
                  <div>
                    {classrooms &&
                      classrooms.map((classroom, index) => (
                        <button
                          onClick={handleClassroomSelect}
                          value={[classroom.sinifname, classroom.id]}
                          key={index}
                          className={`${style.option} ${
                            classroomIds.includes(classroom.id)
                              ? style.selected
                              : ""
                          }`}
                        >
                          {classroom.sinifname}
                        </button>
                      ))}
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className={style.input}>
            <div className={style.inputtitle}>Başlangıç Tarihi</div>
            <div className={style.inputtext}>
              <DatePicker
                className="bg-transparent border-0 outline-none pt-1 w-full "
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                dateFormat="dd/MM/yyyy"
                locale={tr}
                showPopperArrow={false}
                timeZone="UTC+3"
              />

              <img src={calendar} className={style.icon}></img>
            </div>
          </div>
          <div className={style.input}>
            <div className={style.inputtitle}>Bitiş Tarihi</div>
            <div className={style.inputtext}>
              <DatePicker
                className="bg-transparent border-0 outline-none pt-1 w-full "
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                dateFormat="dd/MM/yyyy"
                locale={tr}
                showPopperArrow={false}
                timeZone="UTC+3"
              />

              <img src={calendar} className={style.icon}></img>
            </div>
          </div>
          <div className={style.input}>
            <div className={style.inputtitle}>Yer</div>
            <input
              className={style.inputtext}
              value={place}
              onChange={(e) => setPlace(e.target.value)}
            ></input>
          </div>
          <div className={style.input}>
            <div className={style.inputtitle}>MEB Onay Yazısı Ekle</div>
            <div className={style.inputtext}>
              {photo === null ? "Dosya Yok" : "Dosya Seçildi"}
            </div>
            <div className={style.addButton}>
              <input
                className={style.photoinput}
                type="file"
                name="file"
                id="upload-file"
                onChange={(event) => {
                  setMebfile(event.target.files[0]);
                }}
              ></input>
              EKLE
            </div>
          </div>
          <div className={style.input}>
            <div className={style.inputtitle}>Medya Ekle</div>
            <div className={style.inputtext}>
              {photo === null ? "Fotoğraf Yok" : "Fotoğraf Seçildi"}
            </div>
            <div className={style.addButton}>
              <input
                className={style.photoinput}
                type="file"
                name="photo"
                id="upload-photo"
                onChange={(event) => {
                  setPhoto(event.target.files[0]);
                }}
              ></input>
              EKLE
            </div>
          </div>
          <div className={style.input}>
            <div className={style.inputtitle}>Etkinlik Tutarı</div>
            <input
              className={style.inputtext}
              value={price}
              onChange={(e) => {
                const value = e.target.value;
                // Sadece sayısal değerleri kabul etmek için kontrol yapılıyor
                if (/^\d*$/.test(value)) {
                  setPrice(value);
                }
              }}
              inputMode="numeric"
            ></input>
          </div>
        </div>
        <div className={style.lowertabs}>
          <div className={style.tableftside}>
            <div className={style.tab1}>
              <button
                className={style.tabicon1}
                onClick={() => {
                  deletePaymentMethod();
                }}
              >
                <img alt="" src={deleteicon}></img>
              </button>
              <div className={style.tabtext1}>Sil</div>
            </div>
          </div>
          <div className={style.tabrightside}>
            <div className={style.tab}>
              <button
                className={style.tabicon}
                onClick={() => {
                  editPaymentMethod();
                }}
              >
                <img alt="" src={save}></img>
              </button>
              <div className={style.tabtext}>Kaydet</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditPaymentModal;
